import React from 'react';
import { connect } from 'react-redux';
import { Button, Type } from '@americanexpress/aqx-components';
import { makeGetCardData } from '../redux';
import {
  mapUrlWithDtmLinkQuery,
  sendDTMClickEvent
} from 'service_modules/models/dtm-tagging';
import styles from '../__styles__/learnMoreCta.scss?modules';

const LearnMoreCta = ({ cardData }) => {
  const { learnMore } = cardData;
  const ctaUrl = mapUrlWithDtmLinkQuery(learnMore?.url, learnMore?.dtmTag);
  const handleCtaClick = () => {
    sendDTMClickEvent(learnMore.dtmTag);
  };

  return (
    <Button
      Component="a"
      className={styles.lMButton}
      $type={Type.Secondary}
      href={ctaUrl}
      onClick={handleCtaClick}
      aria-label={`${learnMore?.title} for ${cardData.cardTitle}`}
    >
      <p>{learnMore?.title}</p>
    </Button>
  );
};

const mapStateToProps = () => {
  const getCardData = makeGetCardData();
  return (state, { shortName }) => ({
    cardData: getCardData(state, shortName)
  });
};

export default connect(mapStateToProps)(LearnMoreCta);
